// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { color } from "@awc/XDL/Utilities";
import { autocompleteContentStyles } from "@insite/content-library/Widgets/Header/AutocompleteContent";
import { css } from "styled-components";

autocompleteContentStyles.link = {
    typographyProps: {
        ellipsis: true,
        css: css`
            &&& {
                width: 100%;
                text-align: left;
                margin: 5px 0;
                color: ${color("common.ui14")};
                &:hover {
                    color: ${color("common.ui8")};
                }
            }
        `,
    },
    css: css`
        width: 100%;
        overflow: hidden;
    `,
};
